import React, { useEffect, useState } from 'react'
import DistanceInKm from 'tennders-common/components/DistanceInKM'
import { gCurrency } from 'tennders-stracture/libs/utils'
import GLoading from 'tennders-market/common/components/element/GLoading'
import get from 'lodash/get'
import DOMPurify from 'dompurify'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowsAltH, faCalendar, faChevronRight, faMapMarkedAlt, faTruck } from '@fortawesome/free-solid-svg-icons'

const TSummary = ({ transaction, t }) => {
  const [pickupDate, setPickupDate] = useState()
  const [pickupTime, setPickupTime] = useState()
  const [deliveryDate, setDeliveryDate] = useState()
  const [deliveryTime, setDeliveryTime] = useState()
  const [detailedInfo, setDetailedInfo] = useState()

  useEffect(() => {
    let pDate = get(transaction, 'pickupRoute.date')
    if (pDate?.d && pDate?.t) {
      setPickupDate(get(transaction, 'pickupRoute.date.d'))
      setPickupTime(get(transaction, 'pickupRoute.date.t'))
    } else {
      setPickupDate(get(transaction, 'pickupRoute.date.f'))
    }
    let dDate = get(transaction, 'deliveryRoute.date')
    if (dDate?.d && dDate?.t) {
      setDeliveryDate(get(transaction, 'deliveryRoute.date.d'))
      setDeliveryTime(get(transaction, 'deliveryRoute.date.t'))
    } else {
      setDeliveryDate(get(transaction, 'deliveryRoute.date.f'))
    }
    let _detailedInfo = get(transaction, 'matchedTruck.detailedInfo') || get(transaction, 'matchedLoad.detailedInfo')
    if (!_detailedInfo) {
      const matchedUnit = get(transaction, 'matchedTruck') || get(transaction, 'matchedLoad')
      if (matchedUnit) {
        _detailedInfo = get(matchedUnit, 'paymentTerm.type') + ', (' + get(matchedUnit, 'priceType') + ') ' + gCurrency(get(matchedUnit, 'targetPrice'))
      }
    }
    setDetailedInfo(_detailedInfo)
  }, [transaction])

  return (
    transaction
      ? (
        <div className="col-2">
          <div className="p-20">
            <h3 className="bold">
              {transaction.matchedLoad
                ? t('modals:shipmentSummary')
                : t('modals:truckSummary')}
            </h3>
            <div className="hr" />
            <div className="tennders-transaction-summary-grid">
              <FontAwesomeIcon icon={faMapMarkedAlt} fontSize={24} aria-hidden="true" />
              <span className="bold">
                {transaction.pickupRoutes?.length > 0
                  ? (
                    transaction.pickupRoutes?.map((route, index) => (
                      <React.Fragment key={route?.id || index}>
                        {index + 1 + '. ' + route?.label}
                        <br />
                        <br />
                      </React.Fragment>
                    ))
                  )
                  : transaction.pickupRoute && <span className="bold">{transaction.pickupRoute?.label}</span>}
              </span>
              <div>
                <div className="text-12">
                  <DistanceInKm value={transaction.distanceInKms} />
                </div>
                <FontAwesomeIcon icon={faArrowsAltH} fontSize={24} aria-hidden="true" />
              </div>
              <span className="bold">
                {transaction.deliveryRoutes?.length > 0
                  ? (
                    transaction.deliveryRoutes?.map((route, index) => (
                      <React.Fragment key={route?.id || index}>
                        {index + 1 + '. ' + route?.label}
                        <br />
                        <br />
                      </React.Fragment>
                    ))
                  )
                  : <span>{t('modals:no_delivery_prefence')}</span>}
              </span>
            </div>
            <div className="hr" />
            <div className="tennders-transaction-summary-grid">
              <FontAwesomeIcon icon={faCalendar} fontSize={24} aria-hidden="true" />
              <span>
                {pickupDate}
                <br />
                {pickupTime}
              </span>
              <FontAwesomeIcon icon={faChevronRight} fontSize={24} aria-hidden="true" />
              <span>
                {deliveryDate}
                <br />
                {deliveryTime}
              </span>
            </div>
            <div className="hr" />
            <div className="tennders-transaction-summary-grid">
              <FontAwesomeIcon icon={faTruck} fontSize={24} aria-hidden="true" />
              <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(detailedInfo) || '-' }} />
            </div>
          </div>
        </div>
      )
      : <GLoading />
  )
}

export default TSummary
